import { render, staticRenderFns } from "./ImportDocumentWithAI.vue?vue&type=template&id=79b546a4&scoped=true&"
import script from "./ImportDocumentWithAI.vue?vue&type=script&lang=js&"
export * from "./ImportDocumentWithAI.vue?vue&type=script&lang=js&"
import style0 from "./ImportDocumentWithAI.vue?vue&type=style&index=0&id=79b546a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b546a4",
  null
  
)

export default component.exports